import moment from "moment";

/**
 * Datas que são DIAS, não instantes — a validade de um lote é o exemplo.
 *
 * Viajam como ISO e, lidas no fuso local (a Praia está em UTC-1), recuam um
 * dia. Havia um `addDays(+1)` a compensar, mas na base há duas formas gravadas:
 *
 *   "2026-08-15T00:00:00Z"  → o que se grava hoje (data pura convertida pelo mongoose)
 *   "2026-08-15T01:00:00Z"  → meia-noite local convertida para UTC, do passado
 *
 * O +1 acertava na primeira e punha a segunda um dia à frente. Lendo em UTC, as
 * duas dão o dia 15 — e não é preciso migrar nada.
 */
export function momentGuardado(valor) {
  if (!valor) return null;
  const emUtc = moment.utc(valor);
  if (!emUtc.isValid()) return null;
  // Devolve um moment LOCAL no dia certo, e não um moment UTC: assim serve
  // tanto para mostrar como para alimentar um date picker, e um
  // `.format("YYYY-MM-DD")` a seguir volta a gravar o mesmo dia. Com um moment
  // UTC, o picker mostrava a hora convertida e o dia podia voltar a recuar.
  return moment(emUtc.format("YYYY-MM-DD"), "YYYY-MM-DD");
}

/**
 * Formata uma data-pura vinda do servidor, sem a deslocar.
 */
export function formatarDataGuardada(valor, formato = "DD/MM/YYYY") {
  const m = momentGuardado(valor);
  return m && m.isValid() ? m.format(formato) : "";
}

/**
 * Dias até (ou desde) uma data-pura guardada. Negativo se já passou.
 */
export function diasAteDataGuardada(valor) {
  const m = momentGuardado(valor);
  if (!m || !m.isValid()) return null;
  // Ambos truncados ao dia, para não haver meio-dia a mudar o resultado.
  return m.diff(moment().startOf("day"), "days");
}
